import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const EmployersReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                employers:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.EMPLOYERS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, employers: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_EMPLOYERS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employers: action.payload};

        case ActionTypes.EMPLOYERS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_EMPLOYER:
            const nEmployer = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employers: state.employers.concat(nEmployer)};
    
        case ActionTypes.UPDATE_EMPLOYER:
            const uEmployer = action.payload;
            const updatedEmployers = state.employers.map(e => e.id === uEmployer.id ? uEmployer : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employers: updatedEmployers};

        // case ActionTypes.DELETE_EMPLOYER:
        //     const deId = action.payload;
        //     const filteredEmployers = state.employers.filter(e => e.id !== deId);
        //     return {...state, isLoading: false, errMess: null, employers: filteredEmployers};

        default:
            return state;
    }
};